module.exports = {"150204001":"先锋道街道","150204002":"幸福路街道","150204003":"万青路街道","150204004":"富强路街道","150204005":"科学路街道","150204006":"青山路街道","150204007":"自由路街道","150204008":"乌素图街道","150204100":"青福镇","150204101":"兴胜镇","150204401":"包头市装备制造产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150204.json
// module id = 492
// module chunks = 0